import { Autocomplete, Box, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';

const TYPE_OPTIONS = [
    { key: 'standard', label: 'standard' },
    { key: 'premium', label: 'premium' },
    { key: 'ultrapremium', label: 'ultra premium' },
];

const STATUS_OPTIONS = [
    { key: 'brouillon', label: 'Brouillon' },
    { key: 'non attribuee', label: 'Non attribuée' },
    { key: 'en cours', label: 'En cours' },
    { key: 'en retard', label: 'En retard' },
    { key: 'en ligne', label: 'En ligne' },
];

const MONTH_OPTIONS = [
    { key: '1', label: 'Janvier' }, { key: '2', label: 'Février' },
    { key: '3', label: 'Mars' }, { key: '4', label: 'Avril' },
    { key: '5', label: 'Mai' }, { key: '6', label: 'Juin' },
    { key: '7', label: 'Juillet' }, { key: '8', label: 'Août' },
    { key: '9', label: 'Septembre' }, { key: '10', label: 'Octobre' },
    { key: '11', label: 'Novembre' }, { key: '12', label: 'Décembre' },
];

const currentYear = new Date().getFullYear();
const YEAR_OPTIONS = Array.from({ length: 6 }, (_, i) => {
    const y = String(currentYear - 2 + i);
    return { key: y, label: y };
});

export const GenericAutoComplete = ({
    variant = 'statut',
    onValueChange,
    highlightedOptions = [],
    dynamicOptions = [],
    placeholder: placeholderProp,
}) => {
    const { t } = useTranslation();

    const isDynamic = ['account', 'idDevis', 'idTache', 'consultant'].includes(variant);

    const options = isDynamic ? dynamicOptions :
        variant === 'type' ? TYPE_OPTIONS :
            variant === 'month' ? MONTH_OPTIONS :
                variant === 'year' ? YEAR_OPTIONS :
                    STATUS_OPTIONS;

    const placeholder = placeholderProp ?? (
        isDynamic ? (
            variant === 'account' ? t('Tous les comptes') :
                variant === 'idDevis' ? t('Tous les devis') :
                    variant === 'idTache' ? t('Toutes les tâches') :
                        variant === 'consultant' ? t('Tous les consultants') : ''
        ) :
            variant === 'type' ? t('Tous les types') :
                variant === 'month' ? t('Mois') :
                    variant === 'year' ? t('Année') :
                        t('Tous les statuts')
    );

    return (
        <Autocomplete
            value={null}
            inputValue=""
            onInputChange={() => { }}
            filterOptions={(opts) => opts}
            limitTags={0}
            sx={{ '& .MuiAutocomplete-inputRoot': { height: '40px' } }}
            onChange={(_event, newValue) => {
                if (newValue) onValueChange(newValue.key);
            }}
            options={options}
            getOptionLabel={(option) => t(option.label)}
            renderInput={(params) => (
                <TextField
                    {...params}
                    variant="outlined"
                    fullWidth
                    sx={{ height: '40px' }}
                    placeholder={placeholder}
                />
            )}
            renderOption={(props, option) => {
                const isHighlighted = highlightedOptions.includes(option.key);
                return (
                    <li {...props} style={{
                        backgroundColor: isHighlighted ? '#ffe426' : 'white',
                        display: 'flex',
                        justifyContent: 'space-between',
                    }}>
                        <Box>{t(option.label)}</Box>
                        {isHighlighted && <img src="Images/icon-check.png" alt="icon-check" />}
                    </li>
                );
            }}
        />
    );
};